import { useEffect, useRef } from 'react'

import type { DashboardElement } from '../types/dashboard'

import { showAlert } from '~/actions/alertsActions'

import { useDispatch } from 'react-redux'
import { type Config, createSwapy } from 'swapy'

import { mapSlotItemMapToElements } from '../config/dashboardConfig'
import { useDashboardContext } from '../context/DashboardContext/useContext'
import { saveConfiguration } from '../utils/persistence'

const options: Partial<Config> = {
  animation: 'none',
  dragAxis: 'both',
  swapMode: 'drop',
  manualSwap: true
}

const deepCloneElements = (elements: DashboardElement[]): DashboardElement[] => {
  return JSON.parse(JSON.stringify(elements))
}

export const useSwapy = () => {
  const dispatch = useDispatch()
  const containerRef = useRef<HTMLDivElement>(null)

  const { elements, setElements, isConfigurable, swapyRef, resetDashboard } = useDashboardContext()

  useEffect(() => {
    if (!containerRef.current || !isConfigurable) return

    try {
      swapyRef.current = createSwapy(containerRef.current, options)

      swapyRef.current.onSwap((event) => {
        // TODO: SHOULD BE ABLE TO DELETE A EMPTY TILE ONCE IT"S BEEN SWAPPED
        const newSlotItemMap = event.newSlotItemMap.asArray

        setElements((prev) => {
          const previousElements = deepCloneElements(prev)
          const newElements = mapSlotItemMapToElements(previousElements, newSlotItemMap)
          saveConfiguration({ elements: newElements }, 'swapy')
          return newElements
        })

        // TODO: RECALCULATE THE GHOST TILES
      })
    } catch (error) {
      console.error(error)
      dispatch(showAlert({ component: 'alert', type: 'error', message: 'Error creating swapy, resetting dashboard...' }))
      resetDashboard()
    }

    return () => swapyRef.current?.destroy()
  }, [elements, containerRef, setElements, isConfigurable, swapyRef, dispatch, resetDashboard])

  return containerRef
}
